module.exports = "/_next/static/images/asterisk-9077d4bdd30201fbe11fca0f0a28e2fe.svg";